export default "../css/1d7ec92329933fa04ff35ca51d77d855.ttf";